import React from 'react';
import t from '~t';
import { compact } from '~modules/format/number';

import {
  Item,
  ItemTitle,
  ItemInfo,
  ItemActions,
  Button,
} from '~ui';
import { SuperLink, Icon } from '~ui';
import CollectionIcon from './icon';
import CollectionTitle from './title';

export default function CollectionsItemView(props) {
  const {
    _id, title, count, color, cover, level, active, expanded,
    expandable, to, multiselect,
  } = props;
  const { innerRef, isDragging, isDropping, dropHandlers = {} } = props;
  const { onClick, onExpandClick, onRenameClick, onContextMenu, onKeyUp } =
    props;

  return (
    <Item
      ref={innerRef}
      className='ui-collection-item'
      data-expandable={expandable || undefined}
      data-expanded={expanded || undefined}
      data-dragging={isDragging || undefined}
      data-dropping={isDropping || undefined}
      focusable={!multiselect}
      style={{ '--level': level }}
      active={active}
      color={color}
      {...dropHandlers}
    >
      <div
        className='ui-collection-expand'
        title={expanded ? t.s('collapse') : t.s('expand')}
        onMouseUp={onExpandClick}
      >
        <Icon name='arrow_alt' />
      </div>

      {_id > 0 && multiselect ? (
        <input
          className='mr-[var(--padding-small)] accent-accent'
          type='checkbox'
          checked={active}
          onChange={onClick}
        />
      ) : null}

      <CollectionIcon cover={cover} _id={_id} active={active} />

      <ItemTitle>
        <CollectionTitle {...props} />
      </ItemTitle>

      {(props.public || props.collaborators) && (
        <ItemInfo>
          <Icon
            name={props.public ? 'public' : 'user'}
            size='micro'
          />
        </ItemInfo>
      )}

      {count ? (
        <ItemInfo className='ui-collection-count min-w-[var(--padding-medium)]'>
          {compact(count)}
        </ItemInfo>
      ) : null}

      {!multiselect ? (
        <ItemActions>
          <Button
            variant='ghost'
            size='icon'
            title={t.s('more')}
            onClick={onContextMenu}
          >
            <Icon name='more_horizontal' />
          </Button>
        </ItemActions>
      ) : null}

      <SuperLink
        to={to}
        active={active}
        tabIndex='0'
        onClick={onClick}
        onDoubleClick={onExpandClick}
        onContextMenu={onContextMenu}
        onKeyUp={onKeyUp}
      >
        {title}
      </SuperLink>
    </Item>
  );
}
